import {
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CFormTextarea,
  CLoadingButton,
} from '@coreui/react-pro'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import React, { useMemo, useRef, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ToastComponent from 'src/components/common/TaostComponent'
import SponsorService from 'src/service/SponsorService'
import ReactQuill from 'react-quill'
import TeamAlertService from 'src/service/TeamAlertService'

const AddForm = (props) => {
  const [loader, setLoader] = useState(false)

  const validationSchema = Yup.object().shape({
    title: Yup.string().required('Title is required').max(50, '50 Character Limit is allowed.'),
    short_description: Yup.string()
      .required('Short description is required')
      .max(150, '150 Character Limit is allowed.'),
  })

  const [value, setValue] = useState('')
  const quillRef = useRef()

  const formik = useFormik({
    initialValues: {
      title: '',
      short_description: '',
      description: '',
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data) => {
      const formData = new FormData()
      formData.append('title', data.title)
      formData.append('short_description', data.short_description)
      formData.append('description', value)

      setLoader(true)
      TeamAlertService.saveTeamAlert(formData)
        .then((res) => {
          if (res.status === 200) {
            props.fetchUsers()
            ToastComponent(res.message, 'success')
          } else {
            ToastComponent(res.message, 'error')
          }
          setLoader(false)
        })
        .catch((e) => {
          ToastComponent(e.response?.data?.message, 'error')
          setLoader(false)
        })
    },
  })

  // Image handler
  const imageHandler = () => {
    const editor = quillRef.current.getEditor()
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')
    input.click()

    input.onchange = async () => {
      const file = input.files[0]
      if (/^image\//.test(file.type)) {
        const formData = new FormData()
        formData.append('image', file)
        const res = await SponsorService.imageUplaod(formData)
        const url = res?.url
        editor.insertEmbed(editor.getSelection(), 'image', url)
      } else {
        ToastComponent('You could only upload images.', 'error')
      }
    }
  }

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
          ['image', 'link'],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    [],
  )

  return (
    <CForm className="row g-3" onSubmit={formik.handleSubmit}>
      {/* Title */}
      <CCol md={12}>
        <CFormLabel className="fw-bold">Title *</CFormLabel>
        <CFormInput
          name="title"
          value={formik.values.title}
          onChange={formik.handleChange}
          className={
            'form-control' + (formik.errors.title && formik.touched.title ? ' is-invalid' : '')
          }
        />
        {formik.errors.title && formik.touched.title && (
          <CFormFeedback invalid>{formik.errors.title}</CFormFeedback>
        )}
      </CCol>

      {/* Short Description */}
      <CCol md={12}>
        <CFormLabel className="fw-bold">Short Description (For App) *</CFormLabel>
        <CFormTextarea
          name="short_description"
          rows={2}
          value={formik.values.short_description}
          onChange={formik.handleChange}
          className={
            'form-control' +
            (formik.errors.short_description && formik.touched.short_description
              ? ' is-invalid'
              : '')
          }
        />
        {formik.errors.short_description && formik.touched.short_description && (
          <CFormFeedback invalid>{formik.errors.short_description}</CFormFeedback>
        )}
      </CCol>

      {/* Description (Editor) */}
      <CCol md={12}>
        <CFormLabel className="fw-bold">Long Description (For Web) *</CFormLabel>
        <ReactQuill
          theme="snow"
          ref={quillRef}
          value={value}
          onChange={setValue}
          modules={modules}
        />
      </CCol>

      {/* Submit */}
      <CCol md={6}>
        <CLoadingButton type="submit" color="success" variant="outline" loading={loader}>
          Submit
        </CLoadingButton>
      </CCol>
    </CForm>
  )
}

export default AddForm
